import BaseComponentController from "./base_component_controller"
import { computePosition, autoUpdate, offset, flip, shift, arrow } from "@floating-ui/dom"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends BaseComponentController {
  static targets = ["trigger", "content", "arrow"]

  static values = {
    placement: { type: String, default: "top" },
    offset: { type: Number, default: 8 }
  }

  connect() {
    if (!this.hasContentTarget) return
    this.updatePosition = this.updatePosition.bind(this)
  }

  show() {
    if (!this.hasContentTarget) return
    enter(this.contentTarget)
    this.updatePosition()
    this.cleanup = autoUpdate(this.element, this.contentTarget, this.updatePosition)
  }

  hide() {
    if (!this.hasContentTarget) return
    leave(this.contentTarget)

    if (this.cleanup) {
      this.cleanup()
      this.cleanup = null
    }
  }

  updatePosition() {
    computePosition(this.element, this.contentTarget, {
      placement: this.placementValue,
      middleware: [offset(this.offsetValue), flip(), shift(), arrow({ element: this.arrowTarget })]
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(this.contentTarget.style, {
        left: `${x}px`,
        top: `${y}px`
      })

      const basePlacement = placement.split("-")[0]
      const staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right",
      }[basePlacement]

      if (middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow

        Object.assign(this.arrowTarget.style, {
          left: arrowX != null ? `${arrowX}px` : "",
          top: arrowY != null ? `${arrowY}px` : "",
          right: "",
          bottom: "",
          [staticSide]: "-0.275rem"
        })
      }
    })
  }
}
